
export default {
  name: 'ajout-article',
  components: {},
  props: [],
  data () {
    return {
        loading: false,
        loading_attribut: false,
        type_article: "",
        libelle: '',
        minimum: '',
        optimale: '',
        prix: 0,
        attributs: [],
        type: [],
        type_is_selected: false

    }
  },
  computed: {
    type_articles() {
        return this.$store.getters['types']
    },
  },

  mounted () {
    this.$store.dispatch("getTypes");
    this.type= []

  },
  methods: {
        async changeType(id) {
            this.loading_attribut=true

            try {
                await this.$store.dispatch("getType",id)

                this.type= this.$store.getters['type']

                this.attributs= []

                let j = 0;
                for ( let i= 0; i<this.type['attribut_articles'].length ; i++) {
                    this.attributs.push({ valeur: [],  attribut: this.type['attribut_articles'][i].id });
                    j++;
                }
                if (j > 0) {
                    this.type_is_selected = true;
                }

                this.loading_attribut=false 
    
            } catch {
                this.loading_attribut=false 
            }


            console.log(this.attributs)
            

        },

        async submitForm() {

            const isValid = await this.$refs.observer.validate();

            if (isValid) {
                this.loading=true;

                const data = {
                    libelle:  this.libelle,
                    prix: this.prix,
                    minimum: this.minimum,
                    optimale: this.optimale,
                    type_article: this.type_article,
                    attributs: this.attributs
                }

                this.$store.dispatch("saveArticle",data).then(
                    response => {
                        if (response) {
                            this.loading=true;
                            this.$router.push({ path: `/articles/show/${response.id}` }) 
                        } else {
                            this.loading=false;
                        }
                    }
                );    
            }
            
        },
    }
}


